const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTiles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#368CD6"
    },
    d: "M0,170.667h170.667V0H0V170.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1767A3"
    },
    d: "M170.667,170.667h170.667V0H170.667V170.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#368CD6"
    },
    d: "M341.333,170.667H512V0H341.333V170.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1767A3"
    },
    d: "M0,341.333h170.667V170.667H0V341.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#368CD6"
    },
    d: "M170.667,341.333h170.667V170.667H170.667V341.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1767A3"
    },
    d: "M341.333,341.333H512V170.667H341.333V341.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#368CD6"
    },
    d: "M0,512h170.667V341.333H0V512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1767A3"
    },
    d: "M170.667,512h170.667V341.333H170.667V512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#368CD6"
    },
    d: "M341.333,512H512V341.333H341.333V512z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1767A3"
    },
    d: "M28.444,56.889c-2.844,0-4.741-0.948-6.637-2.844c-3.793-3.793-3.793-9.481,0-13.274L40.77,21.807 c3.793-3.793,9.481-3.793,13.274,0c3.793,3.793,3.793,9.481,0,13.274L35.081,54.044C33.185,55.941,31.289,56.889,28.444,56.889"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1767A3"
    },
    d: "M28.444,104.296c-2.844,0-4.741-0.948-6.637-2.844c-3.793-3.793-3.793-9.481,0-13.274L40.77,69.215 c3.793-3.793,9.481-3.793,13.274,0c3.793,3.793,3.793,9.481,0,13.274l-18.963,18.963C33.185,103.348,31.289,104.296,28.444,104.296 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1767A3"
    },
    d: "M75.852,56.889c-2.844,0-4.741-0.948-6.637-2.844c-3.793-3.793-3.793-9.481,0-13.274l18.963-18.963 c3.793-3.793,9.481-3.793,13.274,0s3.793,9.481,0,13.274L82.489,54.044C80.593,55.941,78.696,56.889,75.852,56.889"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#368CD6"
    },
    d: "M199.111,56.889c-2.844,0-4.741-0.948-6.637-2.844c-3.793-3.793-3.793-9.481,0-13.274l18.963-18.963 c3.793-3.793,9.481-3.793,13.274,0s3.793,9.481,0,13.274l-18.963,18.963C203.852,55.941,201.956,56.889,199.111,56.889"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#368CD6"
    },
    d: "M199.111,104.296c-2.844,0-4.741-0.948-6.637-2.844c-3.793-3.793-3.793-9.481,0-13.274 l18.963-18.963c3.793-3.793,9.481-3.793,13.274,0c3.793,3.793,3.793,9.481,0,13.274l-18.963,18.963 C203.852,103.348,201.956,104.296,199.111,104.296"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#368CD6"
    },
    d: "M246.519,56.889c-2.844,0-4.741-0.948-6.637-2.844c-3.793-3.793-3.793-9.481,0-13.274l18.963-18.963 c3.793-3.793,9.481-3.793,13.274,0c3.793,3.793,3.793,9.481,0,13.274l-18.963,18.963C251.259,55.941,249.363,56.889,246.519,56.889 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1767A3"
    },
    d: "M369.778,56.889c-2.844,0-4.741-0.948-6.637-2.844c-3.793-3.793-3.793-9.481,0-13.274l18.963-18.963 c3.793-3.793,9.481-3.793,13.274,0c3.793,3.793,3.793,9.481,0,13.274l-18.963,18.963C374.519,55.941,372.622,56.889,369.778,56.889 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1767A3"
    },
    d: "M369.778,104.296c-2.844,0-4.741-0.948-6.637-2.844c-3.793-3.793-3.793-9.481,0-13.274 l18.963-18.963c3.793-3.793,9.481-3.793,13.274,0c3.793,3.793,3.793,9.481,0,13.274l-18.963,18.963 C374.519,103.348,372.622,104.296,369.778,104.296"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1767A3"
    },
    d: "M417.185,56.889c-2.844,0-4.741-0.948-6.637-2.844c-3.793-3.793-3.793-9.481,0-13.274l18.963-18.963 c3.793-3.793,9.481-3.793,13.274,0s3.793,9.481,0,13.274l-18.963,18.963C421.926,55.941,420.03,56.889,417.185,56.889"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#368CD6"
    },
    d: "M28.444,227.556c-2.844,0-4.741-0.948-6.637-2.844c-3.793-3.793-3.793-9.481,0-13.274l18.963-18.963 c3.793-3.793,9.481-3.793,13.274,0c3.793,3.793,3.793,9.481,0,13.274l-18.963,18.963C33.185,226.607,31.289,227.556,28.444,227.556 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#368CD6"
    },
    d: "M28.444,274.963c-2.844,0-4.741-0.948-6.637-2.844c-3.793-3.793-3.793-9.481,0-13.274l18.963-18.963 c3.793-3.793,9.481-3.793,13.274,0c3.793,3.793,3.793,9.481,0,13.274l-18.963,18.963C33.185,274.015,31.289,274.963,28.444,274.963 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#368CD6"
    },
    d: "M75.852,227.556c-2.844,0-4.741-0.948-6.637-2.844c-3.793-3.793-3.793-9.481,0-13.274l18.963-18.963 c3.793-3.793,9.481-3.793,13.274,0s3.793,9.481,0,13.274l-18.963,18.963C80.593,226.607,78.696,227.556,75.852,227.556"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1767A3"
    },
    d: "M199.111,227.556c-2.844,0-4.741-0.948-6.637-2.844c-3.793-3.793-3.793-9.481,0-13.274 l18.963-18.963c3.793-3.793,9.481-3.793,13.274,0s3.793,9.481,0,13.274l-18.963,18.963 C203.852,226.607,201.956,227.556,199.111,227.556"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1767A3"
    },
    d: "M199.111,274.963c-2.844,0-4.741-0.948-6.637-2.844c-3.793-3.793-3.793-9.481,0-13.274 l18.963-18.963c3.793-3.793,9.481-3.793,13.274,0c3.793,3.793,3.793,9.481,0,13.274l-18.963,18.963 C203.852,274.015,201.956,274.963,199.111,274.963"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1767A3"
    },
    d: "M246.519,227.556c-2.844,0-4.741-0.948-6.637-2.844c-3.793-3.793-3.793-9.481,0-13.274 l18.963-18.963c3.793-3.793,9.481-3.793,13.274,0c3.793,3.793,3.793,9.481,0,13.274l-18.963,18.963 C251.259,226.607,249.363,227.556,246.519,227.556"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#368CD6"
    },
    d: "M369.778,227.556c-2.844,0-4.741-0.948-6.637-2.844c-3.793-3.793-3.793-9.481,0-13.274 l18.963-18.963c3.793-3.793,9.481-3.793,13.274,0c3.793,3.793,3.793,9.481,0,13.274l-18.963,18.963 C374.519,226.607,372.622,227.556,369.778,227.556"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#368CD6"
    },
    d: "M369.778,274.963c-2.844,0-4.741-0.948-6.637-2.844c-3.793-3.793-3.793-9.481,0-13.274 l18.963-18.963c3.793-3.793,9.481-3.793,13.274,0c3.793,3.793,3.793,9.481,0,13.274l-18.963,18.963 C374.519,274.015,372.622,274.963,369.778,274.963"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#368CD6"
    },
    d: "M417.185,227.556c-2.844,0-4.741-0.948-6.637-2.844c-3.793-3.793-3.793-9.481,0-13.274 l18.963-18.963c3.793-3.793,9.481-3.793,13.274,0s3.793,9.481,0,13.274l-18.963,18.963 C421.926,226.607,420.03,227.556,417.185,227.556"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1767A3"
    },
    d: "M28.444,398.222c-2.844,0-4.741-0.948-6.637-2.844c-3.793-3.793-3.793-9.481,0-13.274l18.963-18.963 c3.793-3.793,9.481-3.793,13.274,0c3.793,3.793,3.793,9.481,0,13.274l-18.963,18.963C33.185,397.274,31.289,398.222,28.444,398.222 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1767A3"
    },
    d: "M28.444,445.63c-2.844,0-4.741-0.948-6.637-2.844c-3.793-3.793-3.793-9.481,0-13.274l18.963-18.963 c3.793-3.793,9.481-3.793,13.274,0c3.793,3.793,3.793,9.481,0,13.274l-18.963,18.963C33.185,444.681,31.289,445.63,28.444,445.63"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1767A3"
    },
    d: "M75.852,398.222c-2.844,0-4.741-0.948-6.637-2.844c-3.793-3.793-3.793-9.481,0-13.274l18.963-18.963 c3.793-3.793,9.481-3.793,13.274,0c3.793,3.793,3.793,9.481,0,13.274l-18.963,18.963C80.593,397.274,78.696,398.222,75.852,398.222 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#368CD6"
    },
    d: "M199.111,398.222c-2.844,0-4.741-0.948-6.637-2.844c-3.793-3.793-3.793-9.481,0-13.274 l18.963-18.963c3.793-3.793,9.481-3.793,13.274,0c3.793,3.793,3.793,9.481,0,13.274l-18.963,18.963 C203.852,397.274,201.956,398.222,199.111,398.222"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#368CD6"
    },
    d: "M199.111,445.63c-2.844,0-4.741-0.948-6.637-2.844c-3.793-3.793-3.793-9.481,0-13.274l18.963-18.963 c3.793-3.793,9.481-3.793,13.274,0c3.793,3.793,3.793,9.481,0,13.274l-18.963,18.963 C203.852,444.681,201.956,445.63,199.111,445.63"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#368CD6"
    },
    d: "M246.519,398.222c-2.844,0-4.741-0.948-6.637-2.844c-3.793-3.793-3.793-9.481,0-13.274 l18.963-18.963c3.793-3.793,9.481-3.793,13.274,0c3.793,3.793,3.793,9.481,0,13.274l-18.963,18.963 C251.259,397.274,249.363,398.222,246.519,398.222"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1767A3"
    },
    d: "M369.778,398.222c-2.844,0-4.741-0.948-6.637-2.844c-3.793-3.793-3.793-9.481,0-13.274 l18.963-18.963c3.793-3.793,9.481-3.793,13.274,0c3.793,3.793,3.793,9.481,0,13.274l-18.963,18.963 C374.519,397.274,372.622,398.222,369.778,398.222"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1767A3"
    },
    d: "M369.778,445.63c-2.844,0-4.741-0.948-6.637-2.844c-3.793-3.793-3.793-9.481,0-13.274l18.963-18.963 c3.793-3.793,9.481-3.793,13.274,0c3.793,3.793,3.793,9.481,0,13.274l-18.963,18.963 C374.519,444.681,372.622,445.63,369.778,445.63"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1767A3"
    },
    d: "M417.185,398.222c-2.844,0-4.741-0.948-6.637-2.844c-3.793-3.793-3.793-9.481,0-13.274 l18.963-18.963c3.793-3.793,9.481-3.793,13.274,0c3.793,3.793,3.793,9.481,0,13.274l-18.963,18.963 C421.926,397.274,420.03,398.222,417.185,398.222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiles);
export default __webpack_public_path__ + "static/media/Tiles.4941773e384b27c2a153b7d036ceffae.svg";
export { ForwardRef as ReactComponent };